




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AInfo from '@/components/AInfo.vue';
import { Alpaca } from '@/backend/type';
import { getAlpacaInfo } from '@/backend/requests';
import SelectFarmerPopup from '@/components/SelectFarmerPopup.vue';
import { LPUserInfo, farmerTransfer, retrieve, validateAccount } from '@/utils/web3';
import FarmCardV2 from '@/components/FarmCardV2.vue';
import AlpacaCard from '@/components/AlpacaCard.vue';

@Component({
  components: {
    AlpacaBtn,
    AInfo,
    FarmCardV2,
    AlpacaCard,
    SelectFarmerPopup
  },
})
export default class LPFarmV2 extends Vue {
  public showSelectPopup: boolean = false;
  public choosingFarmer: Alpaca | null = null;
  public curFarmer: Alpaca | null = null;

  get account() {
    return this.$store.getters.getAccount;
  }

  public toggleSelectPopup() {
    this.showSelectPopup = !this.showSelectPopup;
  }

  public selectFarmer(alpaca: Alpaca) {
    this.choosingFarmer = alpaca;
  }

  public confirmFarmer() {
    if (!this.choosingFarmer) {
      return;
    }
    farmerTransfer(this.account, this.choosingFarmer.id, 1);
  }

  public async getCurFarmer() {
    const res = await LPUserInfo(this.account, 1);
    if (res && res.alpacaID !== '0') {
      const id = res.alpacaID;
      const info = await getAlpacaInfo(id);
      if (info) {
        this.curFarmer = info.data;
      }
    }
  }

  public handleSwap() {
    this.toggleSelectPopup();
  }

  public handleFire() {
    retrieve(this.account, 1);
  }

  public handleCancel() {
    this.choosingFarmer = null;
  }

  public goBugAlpa() {
    window.open('https://exchange.pancakeswap.finance/?_gl=1*rclb6p*_ga*MTczMDE3MDM3NC4xNjAyOTA4ODQy*_ga_334KNG3DMQ*MTYxNDIzNzgzMy4yMC4xLjE2MTQyMzc4MzkuMA..#/swap?inputCurrency=0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c&outputCurrency=0xc5e6689c9c8b02be7c49912ef19e79cf24977f03', '_blank');
  }

  public goGetLP() {
    window.open('https://exchange.pancakeswap.finance/#/add/BNB/0xc5E6689C9c8B02be7C49912Ef19e79cF24977f03', '_blank');
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getCurFarmer();
    }
  }
}
